import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/MultipleFileUpload/multiple-file-upload';
import { css } from '@patternfly/react-styles';
export const MultipleFileUploadTitleIcon = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: css(styles.multipleFileUploadTitleIcon, className) }, props), children));
};
MultipleFileUploadTitleIcon.displayName = 'MultipleFileUploadTitleIcon';
//# sourceMappingURL=MultipleFileUploadTitleIcon.js.map